import { render, staticRenderFns } from "./ota-query.vue?vue&type=template&id=201b2a72&scoped=true"
import script from "./ota-query.vue?vue&type=script&lang=js"
export * from "./ota-query.vue?vue&type=script&lang=js"
import style0 from "./ota-query.vue?vue&type=style&index=0&id=201b2a72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b2a72",
  null
  
)

export default component.exports